export const inViewTrackingConfig = {
    name: 'InViewTracking',
    image: 'https://cdn.zappy.app/a26168b9b480805722e50990a838c47c.png',
    screenshot: 'https://cdn.zappy.app/74e1c78c15cf7e7185af9bbd381f6923.png',
    category: 'Zapier Utilities',
    canHaveChildren: true,
    noWrap: true,
    inputs: [{ name: 'sectionName', type: 'string' }],
};
//# sourceMappingURL=config.js.map